import { ActionTypes } from "@/App/constants/actionTypes";
import { Action } from "@/App/actions";
import { PlanBenefitTypes, GeneralTypes } from "@/types";

export interface PlanBenefitSearchState {
  planBenefitSearchResults: {
    results: Array<PlanBenefitTypes.PlanBenefitSearchResults> | [];
    result_count: string;
  };
  planBenefitSearchOptions: GeneralTypes.QueryOptions;
}

const DEFAULT_PLAN_BENEFIT_STATE: PlanBenefitSearchState = {
  planBenefitSearchResults: {
    results: [],
    result_count: "0",
  },
  planBenefitSearchOptions: {
    full_text_search: "",
    order_by: [{ coverage_strategy_id: GeneralTypes.SortOrder.Asc }],
    page_number: 1,
    results_per_page: 20,
  },
};

export default (state: PlanBenefitSearchState = DEFAULT_PLAN_BENEFIT_STATE, action: Action): {} => {
  if (action.type === ActionTypes.SEARCH_FOR_PLAN_BENEFIT_LIST) {
    return {
      ...state,
      planBenefitSearchOptions: action.payload,
      planBenefitSearchResults: DEFAULT_PLAN_BENEFIT_STATE.planBenefitSearchResults,
    };
  } else if (action.type === ActionTypes.SEARCH_FOR_PLAN_BENEFIT_LIST_RESULTS) {
    return {
      ...state,
      planBenefitSearchResults: action.payload,
    };
  } else {
    return state;
  }
};
